import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const QualityGood = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.viewBox ? props.viewBox : "0 0 65 65"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}>
            <rect x="0.25" width="64" height="64" rx="32"  fill={props.bgColor ? props.bgColor: "white"}/>
            <path fillRule="evenodd" clipRule="evenodd" d="M21.7587 28.5163C21.0804 27.8221 21.0804 26.6964 21.7587 26.0022L31.0219 16.5207C31.3476 16.1873 31.7894 16 32.25 16C32.7106 16 33.1524 16.1873 33.4781 16.5207L42.7413 26.0022C43.4196 26.6964 43.4196 27.8221 42.7413 28.5163C42.063 29.2106 40.9633 29.2106 40.285 28.5163L33.9868 22.0697L33.9868 46.2222C33.9868 47.2041 33.2092 48 32.25 48C31.2908 48 30.5132 47.2041 30.5132 46.2222L30.5132 22.0697L24.215 28.5163C23.5367 29.2106 22.437 29.2106 21.7587 28.5163Z" 
             fill={props.color ? props.color: "white"} />
        </SvgStyled>
    );
};

export default QualityGood;
